export const SPACING = {
  SECTION_TOP: 8,
  SECTION_BOTTOM: 8,
  SECTION_GAP: 6,
  HEADING_TOP: 6,
  HEADING_BOTTOM: 12,
  HEADER_MARGIN_B: 3,
  HEADER_MARGIN_Y: 3,
  SUBHEADING_BOTTOM: 3,
  CONTENT_GAP: 2,
  ITEM_GAP: 1.5,
  SMALL_GAP: 1,
  FURTHER_READING_TOP: 5,
  PARAGRAPH_MARGIN: 2.5,
  SUBTITLE_MARGIN: 1.5,
  LOGO_SPACING: 3,
  DIVIDER_SPACING: 4,
};

export const COMPONENT_SPACING = {
  GRID_SPACING: 5,
  GRID_SPACING_LARGE: 6,
  CARD_PADDING: 3,
  CARD_PADDING_LARGE: 4,
  NAVBAR_HEIGHT: 60,
  SECTION_NAV_HEIGHT: 56,
  MIN_TABLE_WIDTH: 800,
  MIN_CELL_WIDTH: 200,
  PAPER_WIDTH: 300,
  PAPER_MIN_WIDTH: 340,
  PAPER_PADDING: 4,
};

export const COMPONENT_FEATURES = {
  PAPER_BORDER_RADIUS: "15px",
};

export const BODY_SPACING = {
  BULLETS_GAP: 1,
  ERROR_MESSAGE_SECTION_PADDING: 2,
  ERROR_MESSAGE_SECTION_MARGIN_TOP: -5,
  ERROR_MESSAGE_SECTION_MARGIN_BOTTOM: 5,
};

export const TEXT_FEATURES = {
  COLLAPSED_SUMMARY_HEIGHT: 120,
  SUMMARY_EXPAND_THRESHOLD: 200,
  MIN_DESCRIPTION_WIDTH: 200,
  MAX_DESCRIPTION_LEN: 60,
  MAX_DESCRIPTION_LEN_LONG: 200,
  MAX_WEBSITE_DISPLAY_LEN: 160,
  LINK_FONT_WEIGHT: 500,
};

export const BUTTON_FEATURES = {
  BUTTON_SPACING: 5,
  BUTTON_GAP: 2,
};

export const LOGO_FEATURES = {
  LOGO_WIDTH: 127,
  LOGO_HEIGHT: 70,
  LOGO_SPACING: 3,
};

export const ICON_FEATURES = {
  ICON_SIZE: 20,
};

export const OBJECT_SIZE = {
  CIRCLE_WIDTH: 60,
  CIRCLE_HEIGHT: 60,
};
